import React, { useContext, useState } from 'react'
import AppToaster from '../../../commonLib/AppToaster';
import *as productDesignCrud from '../../../_crud/productDesignCrud'
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { Container } from '../../../base/Container';
import { LoadingButton } from '../../../commonLib/LoadingButton';
import { loadingMiniContext } from '../../../commonLib/lodingMiniContext';
import { TextBoxTranslater } from '../../../commonLib/TextBoxTranslater';

export function AddProductDesign() {
    const history = useHistory()
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const { id } = useParams()

    const initialValues = {
        ProductId: id,
        Name: "",
        Note: ""
    }

    const Schema = Yup.object().shape({
        Name: Yup.string().min(3, "Name must between 3 to 50 characters").max(50, "Name must between 3 to 50 characters").required("Name is required."),
        Note: Yup.string().required("Note is required."),
    })

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values) => {
            Save(values);
        },
        onReset: (values, { resetForm }) => {
            resetForm();
        },
    });
    const Save = (value) => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true)
        productDesignCrud.Add(value)
            .then(res => {
                setIsLoadingMini(false)
                setIsLoadingLocal(false);
                AppToaster('Added successfully.', 'success')
                history.push("/product/design/" + id + "/dashboard/" + res.data.message)

            }).catch(error => {
                setIsLoadingMini(false)
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }

    return (
        <>
            <Container title="Add Product Design" isProduct={true} isBack="true">
                <form onSubmit={formik.handleSubmit} class="form-horizontal">
                    <div className="row">
                        <div className="col-md-6">
                            <div class="form-group">
                                <div class="col-xs-12">
                                    <label class="control-label no-padding-right">Name</label>
                                    <TextBoxTranslater className="form-control" type="text" placeholder="Name" name="Name" value={formik.values.Name} onChange={(e) => formik.setValues({ ...formik.values, Name: e.target.value })} />
                                    {
                                        formik.touched.Name &&
                                            formik.errors.Name ? (
                                            <label className="text-danger" >
                                                {formik.errors.Name}
                                            </label>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div class="form-group">
                                <div class="col-xs-12">
                                    <label class="control-label no-padding-right"> Note</label>
                                    <TextBoxTranslater className="form-control" type="text" placeholder="Note" name="Note" value={formik.values.Note} onChange={(e) => formik.setValues({ ...formik.values, Note: e.target.value })} />
                                    {
                                        formik.touched.Note &&
                                            formik.errors.Note ? (
                                            <label className="text-danger" >
                                                {formik.errors.Note}
                                            </label>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="clearfix form-actions">
                        <div class="pull-right">
                            {isLoadingLocal ?
                                <LoadingButton />
                                :
                                <button class="btn btn-info" type="submit" expand="block" disabled={!formik.isValid}>
                                    <i class="ace-icon fa fa-check bigger-110"></i>
                                    Add
                                </button>}
                        </div>
                    </div>
                </form>
            </Container >
        </>
    )
}